import React, {useMemo} from 'react';
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import useTheme from "@material-ui/core/styles/useTheme";
import {convertToNumber, dateAndTimeInputFormat} from "../../utils";
import esLocale from '@fullcalendar/core/locales/es';
import {useDialog} from "../Dialog";
import CreateAppointmentDialog from "./CreateAppointmentDialog";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DeleteIcon from '@material-ui/icons/Delete';
import {IconButton} from "@material-ui/core";

const useGetMinMax = (businessHours) => {
    return useMemo(() => {
        let earliestStartTime = {date: null, number: 24}
        let latestEndTime = {date: null, number: 0}

        businessHours.forEach(({startTime, endTime}) => {
            const startTimeNumber = convertToNumber(startTime)
            const endTimeNumber = convertToNumber(endTime)

            if (earliestStartTime.number > startTimeNumber) {
                earliestStartTime = {date: startTime, number: startTimeNumber}
            }

            if (latestEndTime.number < endTimeNumber) {
                latestEndTime = {date: endTime, number: endTimeNumber}
            }
        })
        return {
            earliestStartTime: earliestStartTime.date ? `${earliestStartTime.date}:00` : '00:00:00',
            latestEndTime: latestEndTime.date ? `${latestEndTime.date}:00` : '24:00:00'
        }
    }, [businessHours])
}

const useGetHiddenDays = (businessHours) => {
    return useMemo(() => {
        let hiddenDays = [0, 1, 2, 3, 4, 5, 6]
        businessHours.forEach(({daysOfWeek}) => {
            const currentDay = daysOfWeek[0]
            hiddenDays = hiddenDays.filter(day => day !== currentDay)
        })
        return hiddenDays

    }, [businessHours])
}

const Calendar = ({events, businessHours, supplierId, isAdmin, createBlockedTime, deleteBlockedTime,handleNext}) => {
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
    const {DialogComp, handleClickOpen} = useDialog(CreateAppointmentDialog)
    const {earliestStartTime, latestEndTime} = useGetMinMax(businessHours);
    const hiddenDays = useGetHiddenDays(businessHours);
    const adminCalendarProps = isAdmin ? {
        select: ({endStr, startStr}) => {
            createBlockedTime({endTime: endStr, startTime: startStr, supplierId})
        },
        selectable: true,
        selectOverlap: false
    } : null
    return <><FullCalendar
        businessHours={businessHours}
        plugins={[timeGridPlugin, interactionPlugin]}
        hiddenDays={hiddenDays}
        locale={esLocale}
        direction={'ltr'}
        initialView="timeGridWeek"
        height={'100%'}
        events={events}
        eventOverlap={false}
        selectMinDistance={2}
        slotMaxTime={latestEndTime}
        slotMinTime={earliestStartTime}
        expandRows={true}
        firstDay={1}
        nowIndicator={true}
        allDaySlot={false}
        eventContent={(e) => RenderEventContent(e, isDesktop, isAdmin, deleteBlockedTime, handleClickOpen)}
        slotLabelFormat={{
            hour: '2-digit',
            minute: '2-digit'
        }}
        headerToolbar={{
            start: 'timeGridDay,timeGridWeek',

        }}
        views={{
            timeGridWeek: {weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true},
            timeGridDay: {weekday: 'long', month: 'numeric', day: 'numeric', omitCommas: true}
        }}
        dateClick={({date}) => handleClickOpen({dateStr: dateAndTimeInputFormat(date), supplierId, isAdmin, handleNext})}
        {...adminCalendarProps}
    />
        {DialogComp}
    </>

}

function RenderEventContent(eventInfo, isDesktop, isAdmin, deleteBlockedTime, handleClickOpen) {
    const {drivingEvent} = eventInfo.event.extendedProps
    if (drivingEvent) { // driving event
        return <div style={{display: 'flex', justifyContent: 'center'}}>
            {eventInfo.event.title}
        </div>
    }
    if (!eventInfo.event.title && isAdmin) {//blockedTime
        const {supplierId, blockedTimeId} = eventInfo.event.extendedProps
        return <div style={{display: 'flex', justifyContent: 'center'}}>
            <IconButton color='primary'
                        variant='outlined'
                        aria-label={'delete'}
                        size={'small'}
                        onClick={() => {
                            deleteBlockedTime({supplierId, _id: blockedTimeId})
                        }}><DeleteIcon/></IconButton>
        </div>
    }
    const texts = eventInfo.event.title.split(',')
    const {servicesHash, customerId, appointmentId,customerAddress
    } = eventInfo.event.extendedProps

    return (
        <div style={{overflow: 'hidden', height: '100%', fontSize: '12px'}}
             onClick={() => isAdmin ? handleClickOpen({
                 isAdmin,
                 editMode: true,
                 customerId,
                 servicesHash,
                 dateStr: dateAndTimeInputFormat(eventInfo.event.start),
                 appointmentId,
                 customerAddress
             }) : null}>
            {isDesktop ? <div><b>{eventInfo.timeText}</b></div> : null}
            {texts.map((text, index) => <span key={index}>{text}{index !== texts.length - 1 ? ',' : ''} </span>)}
        </div>
    )
}

export default Calendar;